//planDinner
export const SUCCESS_ITEM_ADD_TO_CART = "The item has been added to your cart"
export const SUCCESS_ITEM_REMOVE_FROM_CART =
  "Order quantity has been changed in your cart."
export const SUCCESS_CART_CLEAR = "Your cart is empty"

//invitePeople
export const INVITE_SENT = (nickName, signUpMethod) =>
  `Invite sent to ${nickName}'s ${signUpMethod}`
export const INVITE_FAILURE = (signUpMethod) =>
  `The ${signUpMethod} you specified is already signed up. Please use a different ${signUpMethod}`
export const NO_DATING_PARTNER = "No dating partner found"
export const NUDGE_SUCCESS = (partnerName) =>
  `We have let ${partnerName} know that you are waiting online`
export const PARTNER_REMOVED = `The link used is invalid or you have been removed as a partner.`

//integration
export const DELIVERY_API_INTEGRATE_ERROR =
  "You do not have access to delivery.com"

//auth
export const OTP_VERIFY_FAILED =
  "We were unable to validate your phone number. Please try again."
export const RESEND_EMAIL_SUCCESS =
  "Verification email sent. Please check your email."
export const OTP_SENT_MESSAGE =
  "An OTP is sent to your number. Please verify your number by entering the OTP"

//orderAndPayment
export const ADDRESS_NOT_DELIVERABLE =
  "This restaurant cannot deliver here! Please try a different address."
export const PAYMENT_PROCESSING =
  "We are processing your order, please do not click on the back button."

//firebaseProvider-combined order
export const ORDER_COMBINED_SUCCESS = (partnerName) =>
  `Your and ${partnerName}'s orders will be combined`
export const ORDER_NOT_COMBINED = "Your orders will not be combined"
export const ORDER_COMBINED_NOTIFY =
  "Your orders combine is requested successfully"

//firebase error
export const LOGIN_FAILED = "Firebase login failed"
export const FIREBASE_INERNET_CONN_DOWN =
  "Firebase Error. Check your internet connection and try again"

//Generic
export const FORBIDDEN_USER = "Forbidden. User not authorised."
export const SOMETHING_WRONG = "Something went wrong."
export const ERROR_SOMETHING_WENT_WRONG =
  "Something went wrong. Please try again."
